import _ from "lodash";
import { useEffect, useState } from 'react';
import { toast } from "react-toastify";
import { api } from '../utils';

export default function useGetItemInfo(itemObj) {
  const { selectedItem } = itemObj;
  const [item, setItem] = useState({success: false, item: {}, loading: false});

  useEffect(() => {
    if(!selectedItem || !selectedItem?.value?.length) return;
    if(_.isEqual({itemObj: item?.itemObj}, {itemObj: itemObj.selectedItem})) return;
    setItem({...item, itemObj: itemObj.selectedItem, loading: true})

    // Encode # symbol for items with that character or it will be truncated
    api.fetch(`Item/GetItemInfo/${selectedItem?.value.replace(/#/g, '%23').replace(/\//g, '%2F')}`)
      .then(response => {
        if(response?.data?.success){
          setItem({success: true, item: response.data.itemInfo, loading:false })
        } else {
           toast.error("Item Info query returned an error")
        }
      })
      .catch(api.catchHandler);

      return () => {
        setItem({success: false, item: {}, loading: false});
      }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemObj]);
  return item;
}